import { ColumnDef } from "@tanstack/react-table";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/src/components/ui/dropdown-menu";
import { EllipsisVerticalIcon } from "lucide-react";
import { Button } from "@/src/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/src/components/ui/dialog";
import { EditCurrencyForm } from "./EditCurrencyForm";
import { Currency } from "./model";
import { Separator } from "@/src/components/ui/separator";
import { WithTooltip } from "@/src/components/wrappers/WithTooltip";

export const columns: ColumnDef<Currency>[] = [
  {
    header: "Code",
    accessorKey: "code",
  },
  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "Symbol",
    accessorKey: "symbol",
  },
  {
    header: () => <WithTooltip content="Current price in euros, used in currency conversions.">Rate</WithTooltip>,
    id: "rate",
    accessorFn: (c) => `${c.rate}${c.overrideRate ? ` (cap ${c.overrideRate})` : ""}`,
  },
  {
    header: () => <WithTooltip content="Latest price in euros fetched from fixer.io.">API Rate</WithTooltip>,
    accessorKey: "apiRate",
  },
  {
    header: () => (
      <WithTooltip
        content={
          <>
            Threshold is the minimum rate difference that must be exceeded <br /> in order for the Rate to be updated
            based on the API Rate.
          </>
        }
      >
        Threshold
      </WithTooltip>
    ),
    accessorKey: "threshold",
  },
  {
    header: () => (
      <WithTooltip
        content={
          <>
            Prices in this currency will be displayed with given precision. <br /> 0 is round to units, 1 is round to
            tens, 10 is round to hundreds. <br /> Use negative values to show decimal places.
          </>
        }
      >
        Precision
      </WithTooltip>
    ),
    accessorKey: "precisionDigits",
  },
  {
    id: "actions",
    size: 32,
    cell({ row }) {
      return (
        <Dialog>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="p-1 h-fit">
                <EllipsisVerticalIcon />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DialogTrigger asChild>
                <DropdownMenuItem>Edit</DropdownMenuItem>
              </DialogTrigger>
            </DropdownMenuContent>
          </DropdownMenu>
          <DialogContent>
            <DialogTitle>
              <DialogHeader>
                <h2 className="text-3xl">Edit - {row.original.name}</h2>
              </DialogHeader>
            </DialogTitle>
            <Separator />
            <EditCurrencyForm currency={row.original} />
          </DialogContent>
        </Dialog>
      );
    },
  },
];
